import { Dropdown } from 'antd';

const ActionMenu = ({ menu, items, disabled = false, loading = false }) => {
    const handleMenuClick = ({ key }) => {
        const selected = items?.find((item) => item.key === key);
        if (selected?.action) {
            selected.action();
        }
    };

    const menuProps = {
        items,
        onClick: handleMenuClick,
    };

    return (
        <Dropdown
                disabled={disabled}
                loading={loading}
                menu={menuProps}
                trigger={['click']}>
            {/*Input button or item */}
            {menu}
        </Dropdown>
    );
};

export default ActionMenu;